import React, { useEffect, useState, useCallback } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Logo from "../../assets/images/logo-white.svg"
import BackArrow from "../../assets/images/icons/left-arrow.svg"
import DownloadIcon from "../../assets/images/icons/green/download.svg"
import FacebookIcon from "../../assets/images/icons/green/facebook.svg"
import WhatsAppIcon from "../../assets/images/icons/green/whatsapp.svg"
import LinkIcon from "../../assets/images/icons/green/link.svg"
import XIcon from "../../assets/images/icons/green/x.com.svg"
import InfoIcon from "../../assets/images/icons/info-square.svg"
import OfficialAirlinePartner from "../../assets/images/OfficialAirlinePartner.svg"
import bgImg from "../../assets/images/bg-img.png"
import { Link } from 'react-router-dom';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { useLanguage } from "../../context/LanguageContext";
import { getLocalizedFieldValue } from "../../utils/language";
import axios from "axios";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { toast } from "react-toastify";
import parse from "html-react-parser";
import he from "he";

const buildMediaUrl = (path = "") => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  const base = (process.env.REACT_APP_API || "").replace(/\/+$/, "");
  if (!base) return path;
  const normalizedBase = base.replace(/\/v1$/i, "");
  return `${normalizedBase}/${path.replace(/^\/+/, "")}`;
};

function Index() {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const quizId = searchParams.get("quizId");
    const userId = searchParams.get("userId");
    const matchId = searchParams.get("matchId");
    const stepParam = searchParams.get("step");
    const { language } = useLanguage();
    const [quizData, setQuizData] = useState(null);
    const [matchData, setMatchData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showInfoModal, setShowInfoModal] = useState(false);
    const [currentMatchIndex, setCurrentMatchIndex] = useState(0);
    // Store scores for each match: { matchId: { teamA: score, teamB: score } }
    const [matchScores, setMatchScores] = useState({});
    // Track current step in the form flow: 'prediction' | 'entry' | 'survey' | 'confirmation'
    // Use URL param if available, otherwise default to 'prediction'
    const [currentStep, setCurrentStepState] = useState(stepParam || 'prediction');
    
    // Function to update step and URL params
    const setCurrentStep = useCallback((newStep, additionalParams = {}) => {
        setCurrentStepState(newStep);
        const newParams = new URLSearchParams(searchParams);
        newParams.set('step', newStep);
        if (additionalParams.userId) newParams.set('userId', additionalParams.userId);
        if (additionalParams.matchId) newParams.set('matchId', additionalParams.matchId);
        // Keep existing params
        if (quizId) newParams.set('quizId', quizId);
        setSearchParams(newParams, { replace: true });
    }, [searchParams, setSearchParams, quizId]);
    
    // Sync step with URL param on mount or when URL changes
    useEffect(() => {
        if (stepParam && stepParam !== currentStep) {
            setCurrentStepState(stepParam);
        }
    }, [stepParam, currentStep]);
    // Form data for entry form
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        country: "",
        ageRange: "",
        // terms: false,
        // marketing: false,
        rememberMe: false,
        terms_and_conditions: false,
        opt_in: false,
        curent_language : "",
        utm_source : "",
        utm_medium : "",
        utm_campaign: "",
        utm_content: "",
        utm_term : ""
    });
    const [submitting, setSubmitting] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    // Survey state
    const [surveyQuestions, setSurveyQuestions] = useState([]);
    const [surveyLoading, setSurveyLoading] = useState(false);
    const [surveyResponses, setSurveyResponses] = useState({}); // { questionId: [optionIds] }
    const [predictionSurveyFormId, setPredictionSurveyFormId] = useState(null);
    const [submittingSurvey, setSubmittingSurvey] = useState(false);
    const [surveyErrors, setSurveyErrors] = useState({});
    // Token and existing user state
    const [hasToken, setHasToken] = useState(false);
    // PDF export state
    const [exportingPDF, setExportingPDF] = useState(false);
    const [pdfUserData, setPdfUserData] = useState(null);
    // Link copy state
    const [linkCopied, setLinkCopied] = useState(false);
    // User data loading state
    const [loadingUserData, setLoadingUserData] = useState(false);
    const [existingPrediction, setExistingPrediction] = useState(null);
    const [checkingToken, setCheckingToken] = useState(false);
    // Country list state
    const [countries, setCountries] = useState([]);
    const [countriesLoading, setCountriesLoading] = useState(false);

    const [privacyLink, setPrivacyLink] = useState("");
      const fetchPrivacyLink = useCallback(async () => {
      try {
        const response = await handleApiCall(
          "get",
          `${endpoints.getContent}?type=privacy_policy`
        );    
        if (response?.data?.success) {
          const data = response.data.data;
    
          const link =
            language === "AR"
              ? data?.description_ar || data?.description_en
              : data?.description_en || data?.description_ar;      
          setPrivacyLink(link);
        }
      } catch (error) {
        console.error("Privacy link fetch error:", error);
      }
    }, [language]);
    
    useEffect(() => {
      fetchPrivacyLink();
    }, [fetchPrivacyLink]);

    // Check if match is locked (current date < unlock_date OR current date/time > end_date/end_time)
    const isMatchLocked = (unlockDate, endDate, endTime) => {
        const now = new Date();
        
        // Check if locked before unlock date
        if (unlockDate) {
            const unlock = new Date(unlockDate);
            // Reset time to compare only dates
            unlock.setHours(0, 0, 0, 0);
            const nowDateOnly = new Date(now);
            nowDateOnly.setHours(0, 0, 0, 0);
            if (nowDateOnly < unlock) {
                return true;
            }
        }
        
        // Check if locked after end date/time
        if (endDate) {
            let endDateTime = new Date(endDate);
            
            // If end_time is provided separately, combine it with end_date
            if (endTime) {
                const [hours, minutes, seconds] = endTime.split(':').map(Number);
                endDateTime.setHours(hours || 0, minutes || 0, seconds || 0, 0);
            } else {
                // Use the time from endDate if it's a full datetime string
                // If endDate only has date, it will default to 00:00:00
                if (!endDate.includes('T')) {
                    endDateTime.setHours(23, 59, 59, 999); // End of day if only date provided
                }
            }
            
            // Compare with current time (including time component)
            if (now > endDateTime) {
                return true;
            }
        }
        
        return false;
    };

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant",
        });
        document.body.style.backgroundColor = '#000';
        const innerSection = document.querySelector('.innerSection');
        if (innerSection) {
            innerSection.style.padding = '0';
        }
        return () => {
            document.body.style.backgroundColor = '';
        };
    }, []);

    const fetchQuizDetails = useCallback(async () => {
        if (!quizId) return;
        
        setLoading(true);
        try {
            const response = await handleApiCall("get", `${endpoints.quizDetails}/${quizId}`);
            if (
                response?.data?.code === 200 ||
                response?.data?.code === "200" ||
                response?.data?.success === true
            ) {
                const data = response?.data?.data;
                setQuizData(data?.quize || null);
                setMatchData(Array.isArray(data?.matchData) ? data.matchData : []);
                // Check if prediction_survey_form_id is in quiz data
                if (data?.quize?.prediction_survey_form_id) {
                    setPredictionSurveyFormId(data.quize.prediction_survey_form_id);
                } else if (data?.prediction_survey_form_id) {
                    setPredictionSurveyFormId(data.prediction_survey_form_id);
                }
            } else {
                setQuizData(null);
                setMatchData([]);
            }
        } catch (error) {
            console.error("Error fetching quiz details:", error);
            setQuizData(null);
            setMatchData([]);
        } finally {
            setLoading(false);
        }
    }, [quizId]);

    useEffect(() => {
        fetchQuizDetails();
    }, [fetchQuizDetails]);

    // Fetch country list (with pagination support)
    const fetchCountries = useCallback(async () => {
        setCountriesLoading(true);
        try {
            let allCountries = [];
            let page = 1;
            let hasMore = true;
            
            // Fetch all pages to get complete country list
            while (hasMore) {
                const response = await handleApiCall("get", `${endpoints.countryList}?page=${page}&limit=100`);
                if (
                    response?.data?.code === 200 ||
                    response?.data?.code === "200" ||
                    response?.data?.success === true
                ) {
                    const data = response?.data?.data;
                    if (Array.isArray(data?.data)) {
                        const pageCountries = data.data.filter(country => country.status === 1);
                        allCountries = [...allCountries, ...pageCountries];
                        
                        // Check if there are more pages
                        if (data.pages && page < data.pages) {
                            page++;
                        } else {
                            hasMore = false;
                        }
                    } else {
                        hasMore = false;
                    }
                } else {
                    hasMore = false;
                }
            }

            // // Sort countries alphabetically by name
            // const PRIORITY_COUNTRIES = ["GB", "SA"];
            // allCountries.sort((a, b) => {
            //     const isAPriority = PRIORITY_COUNTRIES.includes(a.code_en);
            //     const isBPriority = PRIORITY_COUNTRIES.includes(b.code_en);

            //     // Priority countries first
            //     if (isAPriority && !isBPriority) return -1;
            //     if (!isAPriority && isBPriority) return 1;

            //     // If both are priority, keep fixed order (UK first, then SA)
            //     if (isAPriority && isBPriority) {
            //         return (
            //             PRIORITY_COUNTRIES.indexOf(a.code_en) -
            //             PRIORITY_COUNTRIES.indexOf(b.code_en)
            //         );
            //     }
            //     const nameA = language === "AR" ? (a.name_ar || a.name_en) : (a.name_en || a.name_ar);
            //     const nameB = language === "AR" ? (b.name_ar || b.name_en) : (b.name_en || b.name_ar);
            //     return nameA.localeCompare(nameB);
            // });
            
            setCountries(allCountries);
        } catch (error) {
            console.error("Error fetching countries:", error);
            setCountries([]);
        } finally {
            setCountriesLoading(false);
        }
    }, [language]);

    // Fetch survey questions
    const fetchSurveyQuestions = useCallback(async () => {
        setSurveyLoading(true);
        try {
            const response = await handleApiCall("get", endpoints.surveyQuestionsList);
            if (
                response?.data?.code === 200 ||
                response?.data?.code === "200" ||
                response?.data?.success === true
            ) {
                const data = response?.data?.data;
                // Handle different response structures
                let normalized = [];
                if (Array.isArray(data?.data)) {
                    normalized = data.data;
                } else if (Array.isArray(data)) {
                    normalized = data;
                }
                // Filter only active questions (status === 1)
                setSurveyQuestions(normalized.filter(q => q.status === 1));
            } else {
                setSurveyQuestions([]);
            }
        } catch (error) {
            console.error("Error fetching survey questions:", error);
            setSurveyQuestions([]);
        } finally {
            setSurveyLoading(false);
        }
    }, []);

    // Check for token and fetch existing user data
    const checkTokenAndFetchUser = useCallback(async (matchId) => {
        const token = localStorage.getItem('token');
        if (!token || !matchId) {
            setHasToken(false);
            return;
        }

        setCheckingToken(true);
        try {
            // Make direct axios call to include x-user-token header
            const response = await axios({
                method: "get",
                url: `${process.env.REACT_APP_API}${endpoints.getUserByToken}?match_id=${matchId}`,
                headers: {
                    'x-user-token': token
                }
            });
            
            if (
                response?.data?.code === 200 ||
                response?.data?.code === "200" ||
                response?.data?.success === true
            ) {
                const predictionData = response?.data?.data;
                const message = response?.data?.message || "";
                
                // Check if response indicates no token or empty data (new user)
                if (message === "No token provided" || !predictionData || Object.keys(predictionData).length === 0) {
                    // New user - clear token and show initial forms
                    localStorage.removeItem('token');
                    localStorage.removeItem('sessionToken');
                    setHasToken(false);
                    setExistingPrediction(null);
                    setCurrentStep('prediction');
                    return;
                }
                
                // User data found - store it but always show prediction screen first
                setExistingPrediction(predictionData);
                setHasToken(true);
                
                // Get score data from response
                const scoreData = predictionData?.score;
                
                // Set the user_id as prediction_survey_form_id and update URL
                if (scoreData?.user_id) {
                    setPredictionSurveyFormId(scoreData.user_id);
                    // Update URL with userId and matchId - always add them when found
                    const newParams = new URLSearchParams(searchParams);
                    newParams.set('userId', scoreData.user_id);
                    if (scoreData?.match_id) {
                        newParams.set('matchId', scoreData.match_id);
                    }
                    // Preserve existing params
                    if (quizId) newParams.set('quizId', quizId);
                    // Preserve current step from URL or use 'prediction'
                    const currentStepFromUrl = searchParams.get('step') || 'prediction';
                    newParams.set('step', currentStepFromUrl);
                    setSearchParams(newParams, { replace: true });
                } else if (scoreData?.match_id) {
                    // If only matchId is available, still update URL
                    const newParams = new URLSearchParams(searchParams);
                    newParams.set('matchId', scoreData.match_id);
                    if (quizId) newParams.set('quizId', quizId);
                    const currentStepFromUrl = searchParams.get('step') || 'prediction';
                    newParams.set('step', currentStepFromUrl);
                    setSearchParams(newParams, { replace: true });
                }
                
                // Update match scores from API response
                if (scoreData?.match_id && scoreData?.teamA_score !== undefined && scoreData?.teamB_score !== undefined) {
                    setMatchScores(prev => ({
                        ...prev,
                        [scoreData.match_id]: {
                            teamA: scoreData.teamA_score,
                            teamB: scoreData.teamB_score
                        }
                    }));
                }
                
                // Set remember_me checkbox if true in response
                if (predictionData?.remember_me === true) {
                    setFormData(prev => ({
                        ...prev,
                        rememberMe: true
                    }));
                }
                
                // Always show prediction screen first, even if user data exists
                // But preserve the step from URL if it's already set
                const stepFromUrl = searchParams.get('step');
                if (stepFromUrl) {
                    setCurrentStepState(stepFromUrl);
                } else {
                    setCurrentStepState('prediction');
                }
            } else {
                // Token invalid or no data, clear token and show forms
                localStorage.removeItem('token');
                localStorage.removeItem('sessionToken');
                setHasToken(false);
                setExistingPrediction(null);
                setCurrentStep('prediction');
            }
        } catch (error) {
            console.error("Error fetching user by token:", error);
            // On error, clear token and show forms
            localStorage.removeItem('token');
            localStorage.removeItem('sessionToken');
            setHasToken(false);
            setExistingPrediction(null);
        } finally {
            setCheckingToken(false);
        }
    }, [searchParams, setSearchParams, quizId]);

    // Check token when matchId is available from URL (for direct page access)
    useEffect(() => {
        // If matchId is in URL, check token immediately (for direct page access)
        if (matchId) {
            checkTokenAndFetchUser(matchId);
        }
    }, [matchId, checkTokenAndFetchUser]);

    // Check token after quiz details are loaded (for normal flow)
    useEffect(() => {
        // If no matchId in URL, use current match from matchData
        if (!matchId && matchData.length > 0 && currentMatchIndex < matchData.length) {
            const currentMatch = matchData[currentMatchIndex];
            if (currentMatch?._id) {
                checkTokenAndFetchUser(currentMatch._id);
            }
        }
    }, [matchData, currentMatchIndex, matchId, checkTokenAndFetchUser]);

    // Fetch user data when on confirmation page
    const fetchUserDataForConfirmation = useCallback(async () => {
        if (!userId || !matchId) {
            return;
        }

        setLoadingUserData(true);
        try {
            const response = await axios({
                method: "get",
                url: `${process.env.REACT_APP_API}${endpoints.getUserById}?user_id=${userId}&match_id=${matchId}`,
                headers: {
                    'Accept': 'application/json, text/plain, */*'
                }
            });

            if (
                response?.data?.code === 200 ||
                response?.data?.code === "200" ||
                response?.data?.success === true
            ) {
                const userData = response?.data?.data;
                setPdfUserData(userData);
                
                // Update match scores from API response
                if (userData?.score) {
                    const scoreData = userData.score;
                    if (scoreData?.match_id && scoreData?.teamA_score !== undefined && scoreData?.teamB_score !== undefined) {
                        console.log("Updating match scores from API:", {
                            match_id: scoreData.match_id,
                            teamA_score: scoreData.teamA_score,
                            teamB_score: scoreData.teamB_score
                        });
                        setMatchScores(prev => {
                            const updated = {
                                ...prev,
                                [scoreData.match_id]: {
                                    teamA: scoreData.teamA_score,
                                    teamB: scoreData.teamB_score
                                }
                            };
                            console.log("Updated matchScores state:", updated);
                            return updated;
                        });
                    } else {
                        console.log("Score data missing required fields:", scoreData);
                    }
                } else {
                    console.log("No score data in userData:", userData);
                }
            } else {
                console.error("Failed to fetch user data");
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
        } finally {
            setLoadingUserData(false);
        }
    }, [userId, matchId]);

    // Fetch user data when confirmation step is reached
    useEffect(() => {
        if (currentStep === 'confirmation' && userId && matchId && !pdfUserData) {
            fetchUserDataForConfirmation();
        }
    }, [currentStep, userId, matchId, pdfUserData, fetchUserDataForConfirmation]);

    // Fetch countries when entry form is shown
    useEffect(() => {
        if (currentStep === 'entry' && countries.length === 0 && !countriesLoading) {
            fetchCountries();
        }
    }, [currentStep, countries.length, countriesLoading, fetchCountries]);

    // Reset current match index when match data changes and initialize scores
    useEffect(() => {
        if (matchData.length > 0) {
            setCurrentMatchIndex(0);
            // Initialize scores for all matches to 0, but don't overwrite existing scores
            setMatchScores(prev => {
                const updated = { ...prev };
                matchData.forEach(match => {
                    if (match._id && !updated[match._id]) {
                        // Only initialize if score doesn't exist yet
                        updated[match._id] = {
                            teamA: 0,
                            teamB: 0
                        };
                    }
                });
                return updated;
            });
        }
    }, [matchData]);

    // Handle score increment/decrement
    const handleScoreChange = (matchId, team, operation) => {
        if (!matchId) return;
        
        setMatchScores(prev => {
            const currentScores = prev[matchId] || { teamA: 0, teamB: 0 };
            const currentScore = currentScores[team] || 0;
            
            let newScore = currentScore;
            if (operation === 'increment') {
                newScore = currentScore + 1;
            } else if (operation === 'decrement') {
                newScore = Math.max(0, currentScore - 1); // Don't go below 0
            }
            
            return {
                ...prev,
                [matchId]: {
                    ...currentScores,
                    [team]: newScore
                }
            };
        });
    };

    // Handle form submission and step navigation
    const handleSubmitPrediction = async (e) => {
        e.preventDefault();
        // If user has token and data exists
        if (hasToken && existingPrediction) {
            const token = localStorage.getItem('token');
            const scoreData = existingPrediction?.score;
            
            // Get match_id and user_id from existingPrediction.score (from getUserByToken API response)
            const matchId = scoreData?.match_id;
            const userId = scoreData?.user_id;
            
            // Get current match and scores
            if (matchData.length > 0 && currentMatchIndex < matchData.length) {
                const currentMatch = matchData[currentMatchIndex];
                // Use scores for the match_id from API response, or fallback to current match scores
                const targetMatchId = matchId || currentMatch._id;
                const currentScores = matchScores[targetMatchId] || { teamA: 0, teamB: 0 };
                
                // Only call API if token exists, data exists, and we have match_id and user_id from API response
                if (token && matchId && userId) {
                    try {
                        setSubmitting(true);
                        
                        // Call updatePredictScore API
                        const response = await axios({
                            method: "put",
                            url: `${process.env.REACT_APP_API}${endpoints.updatePredictScore}`,
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                            },
                            data: {
                                match_id: matchId,
                                user_id: userId,
                                teamA_score: currentScores.teamA || 0,
                                teamB_score: currentScores.teamB || 0,
                                remember_me: formData.rememberMe || false,
                            }
                        });
                        
                        if (
                            response?.data?.code === 200 ||
                            response?.data?.code === "200" ||
                            response?.data?.success === true
                        ) {
                            // If remember me is unchecked and API is successful, remove token from localStorage
                            if (!formData.rememberMe) {
                                localStorage.removeItem('token');
                                localStorage.removeItem('sessionToken');
                                setHasToken(false);
                            }
                            
                            // Check if survey needs to be filled
                            if (scoreData?.submit_survey === false) {
                                // Redirect to survey form
                                fetchSurveyQuestions();
                                setCurrentStep('survey', { userId, matchId });
                            } else {
                                // Survey already filled, go to confirmation
                                setCurrentStep('confirmation', { userId, matchId });
                            }
                        } else {
                            // API call failed, proceed with normal flow
                            if (scoreData?.submit_survey === false) {
                                fetchSurveyQuestions();
                                setCurrentStep('survey', { userId, matchId });
                            } else {
                                setCurrentStep('confirmation', { userId, matchId });
                            }
                        }
                    } catch (error) {
                        console.error("Error updating predict score:", error);
                        // On error, proceed with normal flow
                        if (scoreData?.submit_survey === false) {
                            fetchSurveyQuestions();
                            setCurrentStep('survey', { userId, matchId });
                        } else {
                            setCurrentStep('confirmation', { userId, matchId });
                        }
                    } finally {
                        setSubmitting(false);
                    }
                } else {
                    // Missing required data, proceed with normal flow
                    if (scoreData?.submit_survey === false) {
                        fetchSurveyQuestions();
                        setCurrentStep('survey', { userId, matchId });
                    } else {
                        setCurrentStep('confirmation', { userId, matchId });
                    }
                }
            } else {
                // No match data, proceed with normal flow
                if (scoreData?.submit_survey === false) {
                    fetchSurveyQuestions();
                    setCurrentStep('survey', { userId, matchId });
                } else {
                    setCurrentStep('confirmation', { userId, matchId });
                }
            }
        } else {
            // Move to entry form step for new users
            setCurrentStep('entry');
        }
    };

    const handleFormChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
        // Clear error for this field when user starts typing
        if (formErrors[name]) {
            setFormErrors(prev => ({ ...prev, [name]: "" }));
        }
    };

    // Static Arabic message for required fields
    const REQUIRED_FIELD_MESSAGE_AR = "هذا الحقل مطلوب";
    const REQUIRED_FIELD_MESSAGE_EN = "This field is required";

    // Update error messages when language changes
    useEffect(() => {
        setFormErrors(prevErrors => {
            if (Object.keys(prevErrors).length === 0) {
                return prevErrors;
            }
            
            const updatedErrors = {};
            
            // Update each error message based on current language and error type
            Object.keys(prevErrors).forEach(fieldName => {
                if (prevErrors[fieldName]) {
                    // Check if it's a required field error
                    if (prevErrors[fieldName] === REQUIRED_FIELD_MESSAGE_AR || 
                        prevErrors[fieldName] === REQUIRED_FIELD_MESSAGE_EN ||
                        prevErrors[fieldName] === "Field is required" ||
                        prevErrors[fieldName] === "الحقل مطلوب" ||
                        prevErrors[fieldName] === "First name is required" ||
                        prevErrors[fieldName] === "Last name is required" ||
                        prevErrors[fieldName] === "Email is required" ||
                        prevErrors[fieldName] === "Country is required" ||
                        prevErrors[fieldName] === "Age range is required" ||
                        prevErrors[fieldName] === "الاسم الأول مطلوب" ||
                        prevErrors[fieldName] === "اسم العائلة مطلوب" ||
                        prevErrors[fieldName] === "البريد الإلكتروني مطلوب" ||
                        prevErrors[fieldName] === "البلد مطلوب" ||
                        prevErrors[fieldName] === "الفئة العمرية مطلوبة") {
                        updatedErrors[fieldName] = language === "AR" ? REQUIRED_FIELD_MESSAGE_AR : REQUIRED_FIELD_MESSAGE_EN;
                    }
                    // Check if it's an invalid email format error
                    else if (prevErrors[fieldName] === "Invalid email format" || 
                             prevErrors[fieldName] === "البريد الإلكتروني غير صحيح") {
                        updatedErrors[fieldName] = language === "AR" ? "البريد الإلكتروني غير صحيح" : "Invalid email format";
                    }
                    // Check if it's terms and conditions error
                    else if (prevErrors[fieldName] === "You must accept the terms and conditions" ||
                             prevErrors[fieldName] === "يجب الموافقة على الشروط والأحكام") {
                        updatedErrors[fieldName] = language === "AR" ? "يجب الموافقة على الشروط والأحكام" : "You must accept the terms and conditions";
                    }
                    // For other errors, keep them as is
                    else {
                        updatedErrors[fieldName] = prevErrors[fieldName];
                    }
                }
            });
            
            return updatedErrors;
        });
    }, [language]);

    const validateEntryForm = () => {
        const newErrors = {};

        if (!formData.firstName.trim()) {
            newErrors.firstName = language === "AR" ? REQUIRED_FIELD_MESSAGE_AR : REQUIRED_FIELD_MESSAGE_EN;
        }

        if (!formData.lastName.trim()) {
            newErrors.lastName = language === "AR" ? REQUIRED_FIELD_MESSAGE_AR : REQUIRED_FIELD_MESSAGE_EN;
        }

        if (!formData.email.trim()) {
            newErrors.email = language === "AR" ? REQUIRED_FIELD_MESSAGE_AR : REQUIRED_FIELD_MESSAGE_EN;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = language === "AR" ? "البريد الإلكتروني غير صحيح" : "Invalid email format";
        }

        if (!formData.country) {
            newErrors.country = language === "AR" ? REQUIRED_FIELD_MESSAGE_AR : REQUIRED_FIELD_MESSAGE_EN;
        }

        if (!formData.ageRange) {
            newErrors.ageRange = language === "AR" ? REQUIRED_FIELD_MESSAGE_AR : REQUIRED_FIELD_MESSAGE_EN;
        }

        // if (!formData.terms) {
        //     newErrors.terms = language === "AR" ? "يجب الموافقة على الشروط والأحكام" : "You must accept the terms and conditions";
        // }
         if (!formData.terms_and_conditions) {
            newErrors.terms_and_conditions = language === "AR" ? "يجب الموافقة على الشروط والأحكام" : "You must accept the terms and conditions";
        }

        setFormErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmitEntry = async (e) => {
        e.preventDefault();
        
        if (!validateEntryForm()) {
            return;
        }

        // Get current match and scores
        if (matchData.length === 0 || currentMatchIndex >= matchData.length) {
            setFormErrors({ submit: language === "AR" ? "لا توجد مباراة محددة" : "No match selected" });
            return;
        }

        const currentMatch = matchData[currentMatchIndex];
        const currentScores = matchScores[currentMatch._id] || { teamA: 0, teamB: 0 };

        setSubmitting(true);
        try {
            const payload = {
                match_id: currentMatch._id,
                first_name: formData.firstName,
                last_name: formData.lastName,
                age_range: formData.ageRange,
                email: formData.email,
                country: formData.country,
                teamA_score: currentScores.teamA || 0,
                teamB_score: currentScores.teamB || 0,
                type: language === "AR" ? "AR" : "EN",
                remember_me: formData.rememberMe || false,
                terms_and_conditions: formData.terms_and_conditions || false,
                opt_in: formData.opt_in || false,
                curent_language: language,
                utm_source : searchParams.get("utm_source") || "",
                utm_medium : searchParams.get("utm_medium") || "",
                utm_campaign : searchParams.get("utm_campaign") || "",
                utm_content :  searchParams.get("utm_content") || "",
                utm_term : searchParams.get("utm_term") || ""
            };

            const response = await handleApiCall("post", endpoints.submitUserPrediction, payload);
            
            if (
                response?.data?.code === 200 ||
                response?.data?.code === "200" ||
                response?.data?.success === true
            ) {
                // Store token in localStorage
                const token = response?.data?.data?.token || 
                              response?.data?.data?.user?.token;
                if (token) {
                    localStorage.setItem('token', token);
                    localStorage.setItem('sessionToken', token); // Also store as sessionToken for API calls
                }
                
                // Get prediction_survey_form_id from response
                // Use user._id from the response as prediction_survey_form_id
                const user = response?.data?.data?.user;
                const formId = user?._id || 
                               response?.data?.data?.prediction_survey_form_id ||
                               response?.data?.prediction_survey_form_id ||
                               quizData?.prediction_survey_form_id;
                if (formId) {
                    setPredictionSurveyFormId(formId);
                    // Update URL with userId
                    const newParams = new URLSearchParams(searchParams);
                    newParams.set('userId', formId);
                    if (currentMatch._id) newParams.set('matchId', currentMatch._id);
                    if (quizId) newParams.set('quizId', quizId);
                    newParams.set('step', 'survey');
                    setSearchParams(newParams, { replace: true });
                }
                // Fetch survey questions and move to survey step
                await fetchSurveyQuestions();
                setCurrentStep('survey', { userId: formId, matchId: currentMatch._id });
            } else {
                setFormErrors({
                    submit: response?.data?.message || (language === "AR" ? "حدث خطأ أثناء الإرسال" : "An error occurred while submitting"),
                });
            }
        } catch (error) {
            console.error("Error submitting prediction:", error);
            setFormErrors({
                submit: error?.response?.data?.message || (language === "AR" ? "حدث خطأ أثناء الإرسال" : "An error occurred while submitting"),
            });
        } finally {
            setSubmitting(false);
        }
    };

    // Handle survey response changes
    const handleSurveyChange = (questionId, optionId, type) => {
        setSurveyResponses(prev => {
            const current = prev[questionId] || [];
            if (type === "single_selection") {
                // For single selection, replace the array with the new option
                return { ...prev, [questionId]: [optionId] };
            } else if (type === "checkbox") {
                // For checkbox, toggle the option
                if (current.includes(optionId)) {
                    return { ...prev, [questionId]: current.filter(id => id !== optionId) };
                } else {
                    return { ...prev, [questionId]: [...current, optionId] };
                }
            }
            return prev;
        });
        // Clear error for this question
        if (surveyErrors[questionId]) {
            setSurveyErrors(prev => ({ ...prev, [questionId]: "" }));
        }
    };

    // Validate survey form
    const validateSurveyForm = () => {
        const newErrors = {};
        surveyQuestions.forEach(question => {
            const responses = surveyResponses[question._id] || [];

            if (question.question_en === "Who do you most frequently watch sports events with?*") {
                return;
            }

            if (responses.length === 0) {
                newErrors[question._id] = language === "AR" 
                    ? "يرجى الإجابة على هذا السؤال" 
                    : "Please answer this question";
            }
        });
        setSurveyErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmitSurvey = async (e) => {
        e.preventDefault();
        
        if (!validateSurveyForm()) {
            return;
        }

        if (!predictionSurveyFormId) {
            setSurveyErrors({ 
                submit: language === "AR" 
                    ? "معرف النموذج غير متوفر" 
                    : "Form ID not available" 
            });
            return;
        }

        setSubmittingSurvey(true);
        setSurveyErrors({});
        
        try {
            // Format form_responses according to API structure
            const formResponses = surveyQuestions.map(question => {
                const optionIds = (surveyResponses[question._id] || []).map(optionId => ({
                    _id: optionId
                }));
                return {
                    question_id: question._id,
                    option_ids: optionIds
                };
            }).filter(response => response.option_ids.length > 0); // Only include answered questions

            const payload = {
                prediction_survey_form_id: predictionSurveyFormId,
                form_responses: formResponses
            };

            const response = await handleApiCall("post", endpoints.submitPredictSurvey, payload);
            
            if (
                response?.data?.code === 200 ||
                response?.data?.code === "200" ||
                response?.data?.success === true
            ) {
                // Move to confirmation step on success
                setCurrentStep('confirmation', { userId: predictionSurveyFormId, matchId });
            } else {
                setSurveyErrors({
                    submit: response?.data?.message || (language === "AR" ? "حدث خطأ أثناء الإرسال" : "An error occurred while submitting"),
                });
            }
        } catch (error) {
            console.error("Error submitting survey:", error);
            setSurveyErrors({
                submit: error?.response?.data?.message || (language === "AR" ? "حدث خطأ أثناء الإرسال" : "An error occurred while submitting"),
            });
        } finally {
            setSubmittingSurvey(false);
        }
    };

    // Generate PDF from HTML
    const generatePDF = useCallback((userData) => {
        const input = document.getElementById("pdfContent");
        
        if (!input) {
            console.error("PDF content element not found");
            setExportingPDF(false);
            return;
        }

        html2canvas(input, { 
            scale: 3,
            backgroundColor: null,
            useCORS: true,
            logging: false
        }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");
            const imgWidth = 210; // A4 width in mm
            const pageHeight = 297; // A4 height in mm
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            let heightLeft = imgHeight;
            let position = 0;

            // Add first page
            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            // Add more pages if content is long
            while (heightLeft > 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }

            // Generate filename
            const teamA = userData?.score?.teamA_score || 0;
            const teamB = userData?.score?.teamB_score || 0;
            const filename = `prediction-${teamA}-${teamB}.pdf`;
            
            pdf.save(filename);
            setExportingPDF(false);
        }).catch((error) => {
            console.error("Error generating PDF:", error);
            setExportingPDF(false);
        });
    }, []);

    // Handle PDF export - use already fetched data
    const handleExportPDF = useCallback(async () => {
        if (!pdfUserData) {
            console.error("User data not available");
            toast.error(language === "AR" ? "البيانات غير متوفرة" : "User data not available");
            return;
        }

        setExportingPDF(true);
        try {
            // Use already fetched data, no need to call API again
            setTimeout(() => {
                generatePDF(pdfUserData);
            }, 100);
        } catch (error) {
            console.error("Error generating PDF:", error);
            setExportingPDF(false);
        }
    }, [pdfUserData, generatePDF, language]);

    // Handle copy link to clipboard
    const handleCopyLink = useCallback(async () => {
        try {
            const currentUrl = window.location.href;
            await navigator.clipboard.writeText(currentUrl);
            // Show visual feedback
            setLinkCopied(true);
            toast.success(language === "AR" ? "تم نسخ الرابط بنجاح!" : "Link copied to clipboard!");
            // Reset after 2 seconds
            setTimeout(() => {
                setLinkCopied(false);
            }, 2000);
        } catch (error) {
            console.error("Failed to copy link:", error);
            // Fallback for older browsers
            const textArea = document.createElement("textarea");
            textArea.value = window.location.href;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                setLinkCopied(true);
                toast.success(language === "AR" ? "تم نسخ الرابط بنجاح!" : "Link copied to clipboard!");
                setTimeout(() => {
                    setLinkCopied(false);
                }, 2000);
            } catch (err) {
                console.error("Fallback copy failed:", err);
                toast.error(language === "AR" ? "فشل نسخ الرابط" : "Failed to copy link");
            }
            document.body.removeChild(textArea);
        }
    }, [language]);

    // Handle social media sharing
    const shareOnTwitter = useCallback(() => {
        const currentUrl = window.location.href;
        const url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}`;
        window.open(url, "_blank");
    }, []);

    const shareOnFacebook = useCallback(() => {
        const currentUrl = window.location.href;
        const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`;
        window.open(url, "_blank");
    }, []);

    const shareOnWhatsApp = useCallback(() => {
        const currentUrl = window.location.href;
        const url = `https://wa.me/?text=${encodeURIComponent(currentUrl)}`;
        window.open(url, "_blank");
    }, []);



// Find the attend-live-sports question dynamically
const attendQuestion = surveyQuestions.find(
  q => q.question_en === "How often do you attend live sports events?*"
);

// Find "Never" option
const neverOptionId = attendQuestion?.options?.find(
  opt => opt.option_en === "Never"
)?._id;

// Selected answer (undefined until user selects)
const attendAnswer = attendQuestion
  ? surveyResponses[attendQuestion._id]?.[0]
  : undefined;

//Hide ONLY when "Never" is selected
const shouldHideWatchWith = attendAnswer === neverOptionId;

// Clear follow-up answer when hidden
useEffect(() => {
  if (shouldHideWatchWith) {
    const watchWithQuestion = surveyQuestions.find(
      q =>
        q.question_en ===
        "Who do you most frequently watch sports events with?*"
    );

    if (watchWithQuestion) {
      setSurveyResponses(prev => {
        const updated = { ...prev };
        delete updated[watchWithQuestion._id];
        return updated;
      });
    }
  }
}, [shouldHideWatchWith]);


    return (
        <>
            <div className='min-[768px]:w-[390px] mt-28 mb-10 md:mt-20 mx-auto'>
                {/* Loading state while checking token */}
                {checkingToken && (
                    <div className='text-white text-center py-10'>
                        {language === "AR" ? "جاري التحميل..." : "Loading..."}
                    </div>
                )}
                {/* Step 1: Prediction Screen */}
                {!checkingToken && currentStep === 'prediction' && (
                <div className=''>
                    <div className='relative mb-10'>
                        <button onClick={() => navigate('/#games')} className="absolute left-6 md:left-0 inset-y-0 my-auto border border-white min-w-20 md:px-4 h-10 md:h-[34px] text-sm font-SaudiaRegular md:rounded-[4px] flex items-center text-white gap-x-2 justify-center">
                            <img src={BackArrow} className='h-[14px]'/>
                            
                            {language === "AR" ? "الرجوع" : "Back"}
                        </button>
                        <img src={Logo} className='w-[122px] table mx-auto'/>
                    </div>
                    <div className='text-center px-5'>
                        {loading ? (
                            <div className='text-white text-center py-10'>
                                {language === "AR" ? "جاري التحميل..." : "Loading..."}
                            </div>
                        ) : quizData ? (
                            <>
                                <h2 className='text-saudiaGreen text-2xl font-SaudiaBoldItalic mb-2.5'>
                                    {getLocalizedFieldValue(quizData, language, "match_title") || 
                                     getLocalizedFieldValue(quizData, language, "title") ||
                                     (language === "AR" ? "توقع وسجل" : "Predict & score")} <br/>
                                    {language === "AR" ? "مع السعودية!" : "with Saudia!"}
                                </h2>
                                <div className='text-sm text-white'>
                                    {(() => {
                                        const desc = getLocalizedFieldValue(quizData, language, "match_description") ||
                                                     getLocalizedFieldValue(quizData, language, "discription") ||
                                                     (language === "AR" 
                                                         ? "ببساطة أرسل توقعك للنتيجة للمباراة القادمة وكن لديك فرصة للفوز بجوائز بما في ذلك التوقيعات والبطاقات والمزيد.." 
                                                         : "Simply submit your score prediction for next fixture and be in with a chance of winning prizes including signed merchandise, match tickets and more..");
                                        const decoded = desc ? he.decode(desc) : "";
                                        return decoded ? parse(decoded) : desc;
                                    })()}
                                </div>
                            </>
                        ) : (
                            <>
                        <h2 className='text-saudiaGreen text-2xl font-SaudiaBoldItalic mb-2.5'>Predict & score <br/>with  Saudia!</h2>
                        <p className='text-sm text-white'>Simply submit your score prediction for the next fixture and be in with a chance of winning prizes including signed merchandise, match tickets and more.</p>
                            </>
                        )}
                    </div>
                    <div className='bg-saudiaGreen p-4 text-center text-white my-4'>
                        <h3 className='text-xs font-SaudiaExtraBoldItalic mb-2'>
                            {quizData ? (
                                getLocalizedFieldValue(quizData, language, "bonus_prize") ||
                                (language === "AR" ? "جائزة إضافية" : "Bonus prize entry")
                            ) : (
                                language === "AR" ? "جائزة إضافية" : "Bonus prize entry"
                            )}
                        </h3>
                        <p className='text-xs'>
                            {language === "AR" 
                                ? "لا تنس العودة وإرسال توقعك التالي! - أكمل 5 توقعات هذا الموسم للدخول في السباق للفوز بجائزة الموسم" 
                                : "Don't forget to come back and submit your next prediction! Complete 5 predictions this season to go into the running to win a season prize"}
                        </p>
                    </div>
                    <div className='overflow-hidden px-4'>
                        <div className='games pt-4 mb-5 arrowSlider relative 
                            [&_.splide\_\_arrows]:absolute
                            [&_.splide\_\_arrows]:z-20
                            [&_.splide\_\_arrows]:!bg-black
                            [&_.splide\_\_arrows]:-top-[6px]
                            [&_.splide\_\_arrows--rtl]:!left-0
                            [&_.splide\_\_arrows--rtl]:!right-auto
                            [&_.splide\_\_arrows]:right-0
                            [&_.splide\_\_arrows]:flex
                            [&_.splide\_\_arrows]:gap-x-2.5
                            [&_.splide\_\_arrows_button]:transform-none
                            [&_.splide\_\_arrows_button]:border
                            [&_.splide\_\_arrows_button]:border-solid
                            [&_.splide\_\_arrows_button]:border-white/40
                            [&_.splide\_\_arrows_button]:bg-transparent
                            [&_.splide\_\_arrows_button]:w-8
                            [&_.splide\_\_arrows_button]:h-8
                            [&_.splide\_\_arrows_button_svg]:fill-white
                            [&_.splide\_\_arrows_button]:opacity-50
                            [&_.splide\_\_arrows_button]:rounded-sm
                            [&_.splide\_\_arrows_button]:relative
                            [&_.splide\_\_arrows_button]:left-0
                            [&_.splide\_\_arrows_button]:right-0
                            [&_.splide\_\_arrows_button:not(:disabled)]:opacity-100
                            [&_li]:w-[95%]
                            [&_.time]:transition-all
                            [&_li:not(.is-active)_.time]:opacity-0
                            [&_.custom-arrow]:!bg-black
                            [&_.custom-arrow_svg]:!hidden'
                        >
                            <Splide
                                key={language}
                                options={ {
                                    focus    : 'center',
                                    rewind: false,
                                    gap   : '0.8rem',
                                    pagination: false,
                                    autoWidth: true,
                                    direction: language === "AR" ? "rtl" : "ltr",
                                    classes: {
                                        prev: 'splide__arrow--prev custom-arrow',
                                        next: 'splide__arrow--next custom-arrow',
                                    }
                                } }
                                onMoved={(splide) => {
                                    setCurrentMatchIndex(splide.index);
                                }}
                            >
                                {matchData.length > 0 ? (
                                    matchData.map((match, index) => {
                                        const formatDate = (dateString) => {
                                            if (!dateString) return "";
                                            const date = new Date(dateString);
                                            return date.toLocaleDateString('en-GB', { 
                                                day: '2-digit', 
                                                month: '2-digit', 
                                                year: '2-digit' 
                                            });
                                        };
                                        
                                        const matchName = getLocalizedFieldValue(match, language, "match_name") || "";
                                        const teamA = getLocalizedFieldValue(match, language, "teamA_name") || "";
                                        const teamB = getLocalizedFieldValue(match, language, "teamB_name") || "";
                                        const startDate = formatDate(match.start_date);
                                         const startTime = match.start_time || "";
                                         const isLocked = isMatchLocked(match.unlock_date, match.end_date, match.end_time);
                                         const unlockDateFormatted = match.unlock_date ? formatDate(match.unlock_date) : "";
                                         const matchId = match._id;
                                         
                                         // Get current scores for this match
                                         const currentScores = matchScores[matchId] || { teamA: 0, teamB: 0 };
                                         const teamAScore = currentScores.teamA || 0;
                                         const teamBScore = currentScores.teamB || 0;
                                         
                                         // Lock icon SVG
                                         const LockIcon = () => (
                                             <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                 <path d="M12.5 7H12V5C12 2.24 9.76 0 7 0C4.24 0 2 2.24 2 5V7H1.5C0.67 7 0 7.67 0 8.5V14.5C0 15.33 0.67 16 1.5 16H12.5C13.33 16 14 15.33 14 14.5V8.5C14 7.67 13.33 7 12.5 7ZM7 1.5C8.93 1.5 10.5 3.07 10.5 5V7H3.5V5C3.5 3.07 5.07 1.5 7 1.5ZM12.5 14.5H1.5V8.5H12.5V14.5Z" fill="white"/>
                                             </svg>
                                         );
                                         
                                         return (
                                             <SplideSlide key={match._id || index}>
                                                 <div className='font-SaudiaBoldItalic text-white mb-3 time'>
                                                     {matchName ? `${matchName}: ` : ""}{startDate} {startTime}
                                                 </div>
                                                 <div className={`p-3 text-center text-white ${isLocked ? 'bg-white/10' : 'bg-white/30'}`}>
                                        <div className='grid grid-cols-2 gap-x-2'>
                                                         <div className={`flex flex-col gap-y-1 py-6 ${isLocked ? 'bg-[#3a3a3a] opacity-60' : 'bg-[#241F20]'}`}>
                                                             <h4 className='font-SaudiaBold text-sm'>{teamA || "Team A"}</h4>
                                                             <h5 className='text-6xl font-SaudiaExtraBold mt-5'>{teamAScore}</h5>
                                                             <div className='flex gap-x-1 [&>div]:w-[60px] [&>div]:h-[34px] text-center [&>div]:flex [&>div]:items-center [&>div]:justify-center justify-center mt-5'>
                                                                 {isLocked ? (
                                                                     <>
                                                                         <div className='bg-white/30 flex items-center justify-center cursor-not-allowed'>
                                                                             <LockIcon />
                                                </div>
                                                                         <div className='bg-white/30 flex items-center justify-center cursor-not-allowed'>
                                                                             <LockIcon />
                                            </div>
                                                                     </>
                                                                 ) : (
                                                                     <>
                                                                         <button
                                                                             type="button"
                                                                             onClick={() => handleScoreChange(matchId, 'teamA', 'decrement')}
                                                                             className='bg-white/30 w-[60px] h-[34px] text-center flex items-center justify-center cursor-pointer border-0 p-0 m-0'
                                                                         >
                                                                             -
                                                                         </button>
                                                                         <button
                                                                             type="button"
                                                                             onClick={() => handleScoreChange(matchId, 'teamA', 'increment')}
                                                                             className='bg-white/30 w-[60px] h-[34px] text-center flex items-center justify-center cursor-pointer border-0 p-0 m-0'
                                                                         >
                                                                             +
                                                                         </button>
                                                                     </>
                                                                 )}
                                                </div>
                                            </div>
                                                         <div className={`flex flex-col gap-y-1 py-6 ${isLocked ? 'bg-[#3a3a3a] opacity-60' : 'bg-[#132257]'}`}>
                                                             <h4 className='font-SaudiaBold text-sm'>{teamB || "Team B"}</h4>
                                                             <h5 className='text-6xl font-SaudiaExtraBold mt-5'>{teamBScore}</h5>
                                                             <div className='flex gap-x-1 [&>div]:w-[60px] [&>div]:h-[34px] text-center [&>div]:flex [&>div]:items-center [&>div]:justify-center justify-center mt-5'>
                                                                 {isLocked ? (
                                                                     <>
                                                                         <div className='bg-white/30 flex items-center justify-center cursor-not-allowed'>
                                                                             <LockIcon />
                                        </div>
                                                                         <div className='bg-white/30 flex items-center justify-center cursor-not-allowed'>
                                                                             <LockIcon />
                                    </div>
                                                                     </>
                                                                 ) : (
                                                                     <>
                                                                         <button
                                                                             type="button"
                                                                             onClick={() => handleScoreChange(matchId, 'teamB', 'decrement')}
                                                                             className='bg-white/30 w-[60px] h-[34px] text-center flex items-center justify-center cursor-pointer border-0 p-0 m-0'
                                                                         >
                                                                             -
                                                                         </button>
                                                                         <button
                                                                             type="button"
                                                                             onClick={() => handleScoreChange(matchId, 'teamB', 'increment')}
                                                                             className='bg-white/30 w-[60px] h-[34px] text-center flex items-center justify-center cursor-pointer border-0 p-0 m-0'
                                                                         >
                                                                             +
                                                                         </button>
                                                                     </>
                                                                 )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SplideSlide>
                                         );
                                    })
                                ) : (
                                <SplideSlide>
                                        <div className='font-SaudiaBoldItalic text-white mb-3 time'>
                                            {language === "AR" ? "لا توجد مباريات متاحة" : "No matches available"}
                                        </div>
                                    <div className='bg-white/30 p-3 text-center text-white'>
                                            <p className='text-sm'>
                                                {language === "AR" 
                                                    ? "لا توجد مباريات متاحة حالياً" 
                                                    : "No matches available at the moment"}
                                            </p>
                                    </div>
                                </SplideSlide>
                                )}
                            </Splide>
                        </div>
                        <div className='flex justify-between my-4'>
                            <label className='text-white flex items-center font-SaudiaRegular text-xs gap-x-2 cursor-pointer'>
                                <input 
                                    type='checkbox' 
                                    name="rememberMe"
                                    checked={formData.rememberMe}
                                    onChange={handleFormChange}
                                    className='w-4 h-4 cursor-pointer'
                                />
                                {language === "AR" ? "تذكرني" : "Remember me"}
                            </label>
                            <span onClick={() => setShowInfoModal(true)} className="cursor-pointer">
                                <img src={InfoIcon} alt="Info" />
                            </span>
                        </div>
                        <div className="">
                            {matchData.length > 0 && currentMatchIndex < matchData.length ? (() => {
                                const currentMatch = matchData[currentMatchIndex];
                                const isLocked = isMatchLocked(currentMatch?.unlock_date, currentMatch?.end_date, currentMatch?.end_time);
                                const formatDate = (dateString) => {
                                    if (!dateString) return "";
                                    const date = new Date(dateString);
                                    return date.toLocaleDateString('en-GB', { 
                                        day: '2-digit', 
                                        month: '2-digit', 
                                        year: '2-digit' 
                                    });
                                };
                                const unlockDateFormatted = currentMatch?.unlock_date ? formatDate(currentMatch.unlock_date) : "";
                                
                                if (isLocked) {
                                    return (
                                        <button 
                                            type="button" 
                                            disabled
                                            className="bg-[#3a3a3a] text-white/60 cursor-not-allowed transition px-16 text-sm font-SaudiaRegular italic w-full h-[50px] border border-black"
                                        >
                                            {language === "AR" 
                                                ? `مفتوح في ${unlockDateFormatted}` 
                                                : `Unlocked On ${unlockDateFormatted}`}
                                        </button>
                                    );
                                }
                                
                                return (
                                    <button 
                                        type="button"
                                        onClick={handleSubmitPrediction}
                                        disabled={submitting}
                                        className="bg-saudiaGreen text-white border border-saudiaGreen hover:bg-saudiaGreen transition px-16 text-sm font-SaudiaExtraBoldItalic w-full h-[50px] capitalize disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {submitting 
                                            ? (language === "AR" ? "جاري الإرسال..." : "Submitting...")
                                            : (language === "AR" ? "شارك توقعاتك" : "Submit prediction")
                                        }
                                    </button>
                                );
                            })() : (
                                <button 
                                    type="button"
                                    onClick={handleSubmitPrediction}
                                    disabled={submitting}
                                    className="bg-saudiaGreen text-white border border-saudiaGreen hover:bg-saudiaGreen transition px-16 text-sm font-SaudiaExtraBoldItalic w-full h-[50px] capitalize disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    {submitting 
                                        ? (language === "AR" ? "جاري الإرسال..." : "Submitting...")
                                        : (language === "AR" ? "شارك توقعاتك" : "Submit prediction")
                                    }
                            </button>
                            )}
                        </div>
                    </div>
                </div>
                )}

                {/* Step 2: Entry Form */}
                {!checkingToken && currentStep === 'entry' && !hasToken && (
                <div className='px-4'>
                    <div className='relative mb-10'>
                        <button onClick={() => setCurrentStep('prediction')} className="absolute left-0 inset-y-0 my-auto border border-white min-w-20 md:px-4 h-10 md:h-[34px] text-sm font-SaudiaRegular md:rounded-[4px] flex items-center text-white gap-x-2 justify-center">
                            <img src={BackArrow} className='h-[14px]'/>
                            {language === "AR" ? "الرجوع" : "Back"}
                        </button>
                        <img src={Logo} className='w-[122px] table mx-auto' alt="Logo"/>
                    </div>
                    <div className='text-center px-2 md:px-4'>
                        <h2 className='text-saudiaGreen text-2xl font-SaudiaExtraBold mb-2.5'>
                            {language === "AR" ? "نموذج الإدخال" : "Entry form"}
                        </h2>
                        <p className='text-sm text-white'>
                            {language === "AR" 
                                ? "ببساطة أدخل تفاصيلك أدناه لإرسال توقعك والانضمام إلى السباق للفوز." 
                                : "Simply enter your details below to submit your prediction and go into the running to win."}
                        </p>
                    </div>
                    <div className=''>
                    <div className='bg-saudiaGreen p-3 text-center text-white mt-5 mb-8'>
                        <h3 className='text-xs font-SaudiaExtraBoldItalic mb-2'>
                            {language === "AR" ? "توقعك" : "Your prediction"}
                        </h3>
                        <div className='grid grid-cols-2 gap-x-2'>
                            {matchData.length > 0 && currentMatchIndex < matchData.length ? (() => {
                                const currentMatch = matchData[currentMatchIndex];
                                const teamA = getLocalizedFieldValue(currentMatch, language, "teamA_name") || "Team A";
                                const teamB = getLocalizedFieldValue(currentMatch, language, "teamB_name") || "Team B";
                                const currentScores = matchScores[currentMatch._id] || { teamA: 0, teamB: 0 };
                                return (
                                    <>
                                        <div className='bg-[#241F20] flex flex-col gap-y-1 py-6'>
                                            <h4 className='font-SaudiaBold text-sm'>{teamA}</h4>
                                            <h5 className='text-6xl font-SaudiaExtraBold'>{currentScores.teamA || 0}</h5>
                                        </div>
                                        <div className='bg-[#132257] flex flex-col gap-y-1 py-6'>
                                            <h4 className='font-SaudiaBold text-sm'>{teamB}</h4>
                                            <h5 className='text-6xl font-SaudiaExtraBold'>{currentScores.teamB || 0}</h5>
                                        </div>
                                    </>
                                );
                            })() : (
                                <>
                            <div className='bg-[#241F20] flex flex-col gap-y-1 py-6'>
                                        <h4 className='font-SaudiaBold text-sm'>Team A</h4>
                                        <h5 className='text-6xl font-SaudiaExtraBold'>0</h5>
                            </div>
                            <div className='bg-[#132257] flex flex-col gap-y-1 py-6'>
                                        <h4 className='font-SaudiaBold text-sm'>Team B</h4>
                                        <h5 className='text-6xl font-SaudiaExtraBold'>0</h5>
                            </div>
                                </>
                            )}
                        </div>
                    </div>
                    <form onSubmit={handleSubmitEntry} className="[&_label]:font-SaudiaBold [&_label]:text-xs [&_label]:mb-1 [&_label]:flex text-white">
                        <div className="block mb-6">
                            <label>{language === "AR" ? "الاسم الأول" : "First name"}</label>
                            <input
                                type="text"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleFormChange}
                                className={`mt-1 w-full p-2 rounded font-SaudiaRegular text-xs h-[42px] bg-transparent border ${formErrors.firstName ? "border-red-500" : "border-white"} focus:outline-none placeholder:text-[#848484]`}
                                placeholder={language === "AR" ? "الاسم الأول" : "First name"}
                            />
                            {formErrors.firstName && <p className="text-red-500 text-sm mt-1">{formErrors.firstName}</p>}
                        </div>
                        <div className="block mb-6">
                            <label>{language === "AR" ? "اسم العائلة" : "Last name"}</label>
                            <input
                                type="text"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleFormChange}
                                className={`mt-1 w-full p-2 rounded font-SaudiaRegular text-xs h-[42px] bg-transparent border ${formErrors.lastName ? "border-red-500" : "border-white"} focus:outline-none placeholder:text-[#848484]`}
                                placeholder={language === "AR" ? "اسم العائلة" : "Last name"}
                            />
                            {formErrors.lastName && <p className="text-red-500 text-sm mt-1">{formErrors.lastName}</p>}
                        </div>
                        <div className="block mb-6">
                            <label>{language === "AR" ? "البريد الإلكتروني" : "Email address"}</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleFormChange}
                                className={`mt-1 w-full p-2 rounded font-SaudiaRegular text-xs h-[42px] bg-transparent border ${formErrors.email ? "border-red-500" : "border-white"} focus:outline-none placeholder:text-[#848484]`}
                                placeholder={language === "AR" ? "البريد الإلكتروني" : "Email address"}
                            />
                            {formErrors.email && <p className="text-red-500 text-sm mt-1">{formErrors.email}</p>}
                        </div>
                        <div className="block mb-6">
                            <label>{language === "AR" ? "بلد الإقامة" : "Country of residence"}</label>
                            <select
                                name="country"
                                value={formData.country}
                                onChange={handleFormChange}
                                disabled={countriesLoading}
                                className={`mt-1 w-full p-2 rounded font-SaudiaRegular text-xs h-[42px] bg-transparent border text-white ${formErrors.country ? "border-red-500" : "border-white"} focus:outline-none placeholder:text-[#848484] ${countriesLoading ? "opacity-50 cursor-not-allowed" : ""}`}
                            >
                                <option value="" className="text-black">
                                    {countriesLoading 
                                        ? (language === "AR" ? "جاري التحميل..." : "Loading...") 
                                        : (language === "AR" ? "اختر..." : "Select…")
                                    }
                                </option>
                                {countries.map((country) => {
                                    const countryName = language === "AR" 
                                        ? (country.name_ar || country.name_en) 
                                        : (country.name_en || country.name_ar);
                                    return (
                                        <option key={country._id} value={countryName} className="text-black">
                                            {countryName}
                                        </option>
                                    );
                                })}
                            </select>
                            {formErrors.country && <p className="text-red-500 text-sm mt-1">{formErrors.country}</p>}
                        </div>
                        <div className="block mb-6">
                        <label>{language === "AR" ? "الفئة العمرية" : "Age range"}</label>
                        <select 
                            name="ageRange" 
                            value={formData.ageRange}
                            onChange={handleFormChange}
                            className={`mt-1 w-full p-2 rounded font-SaudiaRegular text-xs h-[42px] bg-transparent border text-white ${formErrors.ageRange ? "border-red-500" : "border-white"} focus:outline-none placeholder:text-[#848484]`}
                        >
                            <option value="" className="text-black">
                                {language === "AR" ? "اختر..." : "Select…"}
                            </option>
                            <option value="18-24" className="text-black">18-24</option>
                            <option value="25-34" className="text-black">25-34</option>
                            <option value="35-44" className="text-black">35-44</option>
                            <option value="45-54" className="text-black">45-54</option>
                            <option value="55-64" className="text-black">55-64</option>
                            <option value="65+" className="text-black">65+</option>
                        </select>
                        {formErrors.ageRange && <p className="text-red-500 text-sm mt-1">{formErrors.ageRange}</p>}
                        </div>
                        <div className="flex items-start gap-3 mb-4 [&_label]:text-sm font-SaudiaRegular">
                            <input 
                                type="checkbox" 
                                // name="terms"
                                name='terms_and_conditions'
                                checked={formData.terms_and_conditions}
                                onChange={handleFormChange}
                                className="mt-1"
                            />
                            <label className='!font-SaudiaRegular text-xs !block'>
                                {language === "AR" ? (
                                    // <>أبلغ من العمر على الأقل 18 عامًا، وأوافق على شروط وأحكام السحب، وقد قرأت إشعار الخصوصية للخطوط السعودية.</>
                                    <>
                                        أبلغ من العمر على الأقل 18 عامًا، وأوافق على{" "}
                                        <a
                                            // href='/terms-and-conditions'
                                            href="https://saudia.partnerships-hub.com/score_predictor/ar/terms-and-conditions"
                                            target="_blank"
                                            className="underline cursor-pointer text-green-500"
                                        >
                                            شروط وأحكام السحب
                                        </a>
                                        ، وقد قرأت{" "}
                                        <a
                                            href={privacyLink || "#"}
                                            // href="https://www.saudia.com/pages/help/useful-links/legal-and-terms-and-conditions/privacy-policy?sc_lang=ar-SA&sc_country=SA"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="underline cursor-pointer text-green-500"
                                        >
                                            إشعار الخصوصية للخطوط السعودية
                                        </a>
                                    </>
                                ) : (
                                    // <>I am at least 18 years old, agree to the prize draw Terms & Conditions, and have read the Saudia Privacy Notice.</>
                                   <>
                                        I am at least 18 years old, agree to the prize draw{" "}
                                        <a
                                            // href='/terms-and-conditions'
                                            href="https://saudia.partnerships-hub.com/score_predictor/en/terms-and-conditions"
                                            target="_blank"
                                            className="underline cursor-pointer text-green-500"
                                        >
                                            Terms & Conditions
                                        </a>
                                        , and have read the Saudia {" "}
                                        <a
                                            href={privacyLink || "#"}
                                            // href="https://www.saudia.com/pages/help/useful-links/legal-and-terms-and-conditions/privacy-policy?sc_lang=en-SA&sc_country=SA"
                                            target="_blank"
                                            className="underline cursor-pointer text-green-500"
                                        >
                                            Privacy Notice.
                                        </a>
                                    </>
                                )}
                            </label>
                        </div>
                        {formErrors.terms_and_conditions && <p className="text-red-500 text-sm mb-4 -mt-2">{formErrors.terms_and_conditions}</p>}
                        {/* {formErrors.terms && <p className="text-red-500 text-sm mb-4 -mt-2">{formErrors.terms}</p>} */}
                        <div className="flex items-start gap-3 mb-6 [&_label]:text-sm font-SaudiaRegular">
                            {/* <input 
                                type="checkbox" 
                                name="marketing" 
                                checked={formData.marketing}
                                onChange={handleFormChange}
                                className="mt-1"
                            /> */}
                            <input
                                type="checkbox"
                                name="opt_in"
                                checked={formData.opt_in}
                                onChange={handleFormChange}
                                className="mt-1"
                            />
                            <label className='!font-SaudiaRegular text-xs !block'>
                                {language === "AR" ? (
                                    <>بالتأشير على المربع التالي، أوافق على استخدام الخطوط السعودية لمعلوماتي لإبقائي على اطلاع بأحدث العروض الخاصة والأخبار عبر البريد الإلكتروني، وسائل التواصل الاجتماعي، الفيديو الرقمي، والإعلانات المرئية. أفهم أن لدي الحق في إلغاء الاشتراك أو تحديث تفضيلاتي في أي وقت عن طريق التواصل مع الخطوط السعودية (راجع سياسة الخصوصية) أو باتباع تعليمات إلغاء الاشتراك في التواصل ذات الصلة بالشركة.</>
                                ) : (
                                    <>By ticking the following box, I consent to Saudia using my information to keep me up to date with the latest special offers and news via email, social media, digital video and display advertising. I understand I have the right to unsubscribe or update my preferences at any time by contacting Saudia (see Privacy Policy) or by following the unsubscribe instructions on company's relevant communication.</>
                                )}
                            </label>
                        </div>
                        {formErrors.submit && <p className="text-red-500 text-sm mb-4">{formErrors.submit}</p>}
                        <div className="">
                            <button 
                                type="submit" 
                                disabled={submitting}
                                className="bg-saudiaGreen text-white hover:bg-saudiaGreen transition px-16 text-sm font-SaudiaExtraBoldItalic w-full h-[50px] disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {submitting ? (language === "AR" ? "جاري الإرسال..." : "Submitting...") : (language === "AR" ? "اشترك" : "Enter")}
                            </button>
                        </div>
                    </form>
                    </div>
                </div>
                )}

                {/* Step 3: Survey Form */}
                {!checkingToken && currentStep === 'survey' && (
                <div className=''>
                    <div className='relative mb-10'>
                        {/* <button className="absolute left-0 inset-y-0"><img src={BackArrow} alt="Menu"/></button> */}
                        <img src={Logo} className='w-[122px] table mx-auto' alt="Logo"/>
                    </div>
                    <div className='text-center px-2 md:px-6'>
                        <h2 className='text-saudiaGreen text-2xl font-SaudiaExtraBold mb-2.5'>
                            {language === "AR" ? "استبيان" : "Survey"}
                        </h2>
                        <p className='text-sm text-white'>
                            {language === "AR" 
                                ? "تريد 10 فرص إضافية لدخول السحب؟ قم بتعبئة الاستبيان أدناه واحصل على فرص إضافية." 
                                : "Want another 10 extra entries? Fill out the survey below and earn those extra entries."}
                        </p>
                    </div>
                    {surveyLoading ? (
                        <div className='text-white text-center py-10 mt-8'>
                            {language === "AR" ? "جاري التحميل..." : "Loading..."}
                    </div>
                    ) : (
                        <form onSubmit={handleSubmitSurvey} className="[&_label]:font-SaudiaBold [&_label]:text-xs [&_label]:mb-1 [&_label]:flex text-white mt-8 [&_select]:text-[11px] px-4">
                            {surveyQuestions.length > 0 ? (

                            surveyQuestions.map((question) => {
                                // Hide follow-up question ONLY if "Never" is selected
                                if (
                                    question.question_en ===
                                    "Who do you most frequently watch sports events with?*" &&
                                    shouldHideWatchWith
                                ) {
                                    return null;
                                }
                                const questionText =
                                    language === "AR"
                                    ? question.question_ar
                                    : question.question_en;

                                const currentResponse = surveyResponses[question._id] || [];
                                const isSingleSelection = question.type === "single_selection";
                                const isCheckbox = question.type === "checkbox";

                                return (
                                    <div key={question._id} className="block mb-6">
                                    <label className="text-sm font-medium">
                                        {questionText}
                                    </label>

                                    {isSingleSelection ? (
                                        <select
                                        value={currentResponse[0] || ""}
                                        onChange={(e) => {
                                            if (e.target.value) {
                                            handleSurveyChange(
                                                question._id,
                                                e.target.value,
                                                "single_selection"
                                            );
                                            }
                                        }}
                                        className={`mt-1 w-full p-2.5 rounded bg-transparent font-SaudiaRegular border text-white ${
                                            surveyErrors[question._id]
                                            ? "border-red-500"
                                            : "border-white"
                                        } focus:outline-none`}
                                        >
                                        <option value="" className="text-black">
                                            {language === "AR"
                                            ? "الرجاء قم بالاختيار"
                                            : "Please make a selection"}
                                        </option>

                                        {question.options.map((option) => (
                                            <option
                                            key={option._id}
                                            value={option._id}
                                            className="text-black"
                                            >
                                            {language === "AR"
                                                ? option.option_ar
                                                : option.option_en}
                                            </option>
                                        ))}
                                        </select>
                                    ) : isCheckbox ? (
                                        <ul className="flex flex-col gap-y-2 mt-4">
                                        {question.options.map((option) => (
                                            <li key={option._id}>
                                            <label className="cursor-pointer flex items-center gap-x-3">
                                                <input
                                                type="checkbox"
                                                checked={currentResponse.includes(option._id)}
                                                onChange={() =>
                                                    handleSurveyChange(
                                                    question._id,
                                                    option._id,
                                                    "checkbox"
                                                    )
                                                }
                                                />
                                                {language === "AR"
                                                ? option.option_ar
                                                : option.option_en}
                                            </label>
                                            </li>
                                        ))}
                                        </ul>
                                    ) : null}

                                    {surveyErrors[question._id] && (
                                        <p className="text-red-500 text-sm mt-1">
                                        {surveyErrors[question._id]}
                                        </p>
                                    )}
                                    </div>
                                );
                                })


                        //         surveyQuestions.map((question) => {
                        //             const questionText = language === "AR" 
                        //                 ? question.question_ar 
                        //                 : question.question_en;
                        //             const currentResponse = surveyResponses[question._id] || [];
                        //             const isSingleSelection = question.type === "single_selection";
                        //             const isCheckbox = question.type === "checkbox";
                                    
                        //             return (
                        //                 <div key={question._id} className="block mb-6">
                        //                     <label className="text-sm font-medium">
                        //                         {questionText}
                        //                     </label>
                        //                     {isSingleSelection ? (
                        //     <select
                        //                             value={currentResponse[0] || ""}
                        //                             onChange={(e) => {
                        //                                 if (e.target.value) {
                        //                                     handleSurveyChange(question._id, e.target.value, "single_selection");
                        //                                 }
                        //                             }}
                        //                             className={`mt-1 w-full p-2.5 rounded bg-transparent font-SaudiaRegular border text-white ${surveyErrors[question._id] ? "border-red-500" : "border-white"} focus:outline-none placeholder:text-white/30`}
                        //     >
                        //                             <option value="" className="text-black">
                        //                                 {language === "AR" ? "الرجاء قم بالاختيار" : "Please make a selection"}
                        //                             </option>
                        //                             {question.options && question.options.map((option) => {
                        //                                 const optionText = language === "AR" 
                        //                                     ? option.option_ar 
                        //                                     : option.option_en;
                        //                                 return (
                        //                                     <option key={option._id} value={option._id} className="text-black">
                        //                                         {optionText}
                        //                                     </option>
                        //                                 );
                        //                             })}
                        //     </select>
                        //                     ) : isCheckbox ? (
                        //     <ul className="flex flex-col gap-y-2 [&_label]:flex [&_label]:items-center [&_label]:gap-x-3 mt-4">
                        //                             {question.options && question.options.map((option) => {
                        //                                 const optionText = language === "AR" 
                        //                                     ? option.option_ar 
                        //                                     : option.option_en;
                        //                                 const isChecked = currentResponse.includes(option._id);
                        //                                 return (
                        //                                     <li key={option._id}>
                        //                                         <label className="cursor-pointer flex items-center">
                        //                                             <input 
                        //                                                 type="checkbox"
                        //                                                 checked={isChecked}
                        //                                                 onChange={() => handleSurveyChange(question._id, option._id, "checkbox")}
                        //                                                 className="mr-0"
                        //                                             />
                        //                                             {optionText}
                        //                                         </label>
                        //                                     </li>
                        //                                 );
                        //                             })}
                        //     </ul>
                        //                     ) : null}
                        //                     {surveyErrors[question._id] && (
                        //                         <p className="text-red-500 text-sm mt-1">{surveyErrors[question._id]}</p>
                        //                     )}
                        // </div>
                        //             );
                        //         })
                            ) : (
                                <div className='text-white text-center py-10 mt-8'>
                                    {language === "AR" ? "لا توجد أسئلة متاحة" : "No questions available"}
                        </div>
                            )}
                            {surveyErrors.submit && (
                                <p className="text-red-500 text-sm mb-4">{surveyErrors.submit}</p>
                            )}
                            {surveyQuestions.length > 0 && (
                        <div className="flex justify-start items-start mt-8">
                                    <button 
                                        type="submit" 
                                        disabled={submittingSurvey}
                                        className="bg-saudiaGreen text-white hover:bg-gray-950 transition px-16 text-sm font-SaudiaExtraBoldItalic w-full h-[50px] disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {submittingSurvey 
                                            ? (language === "AR" ? "جاري الإرسال..." : "Submitting...") 
                                            : (language === "AR" ? "أدخل" : "Submit")}
                            </button>
                        </div>
                            )}
                    </form>
                    )}
                </div>
                )}

                {/* Step 4: Confirmation Screen */}
                {!checkingToken && currentStep === 'confirmation' && (
                <div className=''>
                    {loadingUserData ? (
                        <div className='text-white text-center py-10'>
                            {language === "AR" ? "جاري التحميل..." : "Loading..."}
                        </div>
                    ) : (
                    <>
                    <div className='relative mb-10'>
                        {/* <button className="absolute left-0 inset-y-0"><img src={BackArrow}/></button> */}
                        <img src={Logo} className='w-[122px] table mx-auto'/>
                    </div>
                    <div className='text-center px-2 md:px-6'>
                        <h2 className='text-saudiaGreen text-2xl font-SaudiaExtraBold mb-2.5'>
                            {language === "AR" ? "توقعاتك" : "Your predictions"}
                        </h2>
                        <p className='text-sm text-white'>
                            {language === "AR" 
                                ? "هل يرغب أيٌّ من أصدقائك أو أفراد عائلتك في المشاركة؟" 
                                : "Would any of your friends or family want to enter?"}
                        </p>
                        <p className='text-sm text-white mt-4'>
                            {language === "AR" 
                                ? "انقر على الأيقونات أدناه لنسخ الرابط أو مشاركة توقعاتك عبر قنواتك الاجتماعية" 
                                : "Click on the icons below to copy the link or share your predictions across your social channels!"}
                        </p>
                    </div>
                    <div className='flex gap-x-4 justify-center mt-6 mb-5'>
                        <button 
                            onClick={handleExportPDF}
                            disabled={exportingPDF || !userId || !matchId}
                            className="cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                            title={language === "AR" ? "تحميل PDF" : "Download PDF"}
                        >
                            <img src={DownloadIcon} alt={language === "AR" ? "تحميل" : "Download"}/>
                        </button>
                        <button 
                            onClick={shareOnTwitter}
                            className="cursor-pointer hover:scale-105 transition-transform duration-300"
                            title={language === "AR" ? "مشاركة على X" : "Share on X"}
                        >
                            <img src={XIcon} alt={language === "AR" ? "X" : "X"}/>
                        </button>
                        <button 
                            onClick={shareOnFacebook}
                            className="cursor-pointer hover:scale-105 transition-transform duration-300"
                            title={language === "AR" ? "مشاركة على فيسبوك" : "Share on Facebook"}
                        >
                            <img src={FacebookIcon} alt={language === "AR" ? "فيسبوك" : "Facebook"}/>
                        </button>
                        <button 
                            onClick={shareOnWhatsApp}
                            className="cursor-pointer hover:scale-105 transition-transform duration-300"
                            title={language === "AR" ? "مشاركة على واتساب" : "Share on WhatsApp"}
                        >
                            <img src={WhatsAppIcon} alt={language === "AR" ? "واتساب" : "WhatsApp"}/>
                        </button>
                        <button 
                            onClick={handleCopyLink}
                            className={`cursor-pointer relative transition-all duration-300 ${
                                linkCopied
                                  ? "scale-110 opacity-80 brightness-125 drop-shadow-[0_0_8px_rgba(0,217,165,0.6)]"
                                  : "hover:scale-105"
                            }`}
                            title={linkCopied ? (language === "AR" ? "تم النسخ!" : "Copied!") : (language === "AR" ? "نسخ الرابط" : "Copy link")}
                        >
                            <img 
                                src={LinkIcon} 
                                alt={language === "AR" ? "نسخ الرابط" : "Copy link"}
                                className="transition-all duration-300"
                            />
                            {linkCopied && (
                                <span 
                                    className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-saudiaGreen text-white text-xs px-2 py-1 rounded whitespace-nowrap z-10 animate-fade-in-out"
                                >
                                    {language === "AR" ? "تم النسخ!" : "Copied!"}
                                </span>
                            )}
                        </button>
                    </div>
                    <div className='px-4 md:px-0'>
                        <div className="bg-saudiaGreen p-3 text-center text-white mb-8 relative overflow-hidden bg-cover bg-center bg-no-repeat">
                        <img src={bgImg} alt="" className="absolute inset-0 w-full h-full object-cover pointer-events-none" />
                        <div className="relative z-10">
                        <div className='mt-3 mb-4 flex justify-center'><img src={OfficialAirlinePartner} alt="Official Airline Partner"/></div>
                        <h3 className='text-2xl font-SaudiaLight mb-0 capitalize'>
                            {language === "AR" ? "" : "Your game"}
                        </h3>
                        <h3 className='text-2xl font-SaudiaBold mb-2 capitalize'>
                            {language === "AR" ? "توقعاتك ليوم المباراة" : "day prediction"}
                        </h3>
                        <div className='grid grid-cols-2 gap-x-2 relative mt-6'>
                            {(() => {
                                // Get match data - prefer from matchData, fallback to matchId from URL
                                let currentMatch = null;
                                let teamA = "Team A";
                                let teamB = "Team B";
                                let teamAScore = 0;
                                let teamBScore = 0;
                                
                                // Try to get match from matchData first
                                if (matchData.length > 0 && currentMatchIndex < matchData.length) {
                                    currentMatch = matchData[currentMatchIndex];
                                    teamA = getLocalizedFieldValue(currentMatch, language, "teamA_name") || "Team A";
                                    teamB = getLocalizedFieldValue(currentMatch, language, "teamB_name") || "Team B";
                                }
                                
                                // Get scores - use matchId from URL or currentMatch._id
                                const targetMatchId = matchId || (currentMatch?._id);
                                if (targetMatchId) {
                                    const currentScores = matchScores[targetMatchId] || { teamA: 0, teamB: 0 };
                                    teamAScore = currentScores.teamA || 0;
                                    teamBScore = currentScores.teamB || 0;
                                    console.log("Confirmation page - Getting scores:", {
                                        targetMatchId,
                                        currentScores,
                                        teamAScore,
                                        teamBScore,
                                        allMatchScores: matchScores
                                    });
                                }
                                
                                return (
                                    <>
                                        <div className='bg-[#241F20] flex flex-col gap-y-1.5 py-2.5'>
                                            <span className='text-[10px] font-SaudiaRegular'>
                                                {language === "AR" ? "المنزل" : "Home"}
                                            </span>
                                            <h4 className='font-SaudiaMedium text-sm'>{teamA}</h4>
                                            <h5 className='text-6xl font-SaudiaExtraBold flex-1 flex items-center justify-center py-2 mt-2.5'>{teamAScore}</h5>
                                        </div>
                                        <div className='absolute text-2xl font-SaudiaBold bg-saudiaGreen px-3 py-2 inset-0 m-auto w-[50px] h-[50px] flex items-center justify-center'>
                                            {language === "AR" ? "ضد" : "Vs"}
                                        </div>
                                        <div className='bg-[#132257] flex flex-col gap-y-1.5 py-2.5 px-2'>
                                            <span className='text-[10px] font-SaudiaRegular'>
                                                {language === "AR" ? "الضيوف" : "Away"}
                                            </span>
                                            <h4 className='font-SaudiaMedium text-sm'>{teamB}</h4>
                                            <h5 className='text-6xl font-SaudiaExtraBold flex-1 flex items-center justify-center py-2 mt-2.5'>{teamBScore}</h5>
                                        </div>
                                    </>
                                );
                            })()}
                            </div>
                        <div className='text-xs font-SaudiaBold mt-5' dir={language === "AR" ? "ltr" : "ltr"}>
                            {(() => {
                                let currentMatch = null;
                                if (matchData.length > 0 && currentMatchIndex < matchData.length) {
                                    currentMatch = matchData[currentMatchIndex];
                                } else if (matchId && matchData.length > 0) {
                                    // Try to find match by matchId
                                    currentMatch = matchData.find(m => m._id === matchId);
                                }
                                
                                const formatDate = (dateString) => {
                                    if (!dateString) return "";
                                    const date = new Date(dateString);
                                    return date.toLocaleDateString('en-GB', { 
                                        day: 'numeric', 
                                        month: 'long', 
                                        year: 'numeric' 
                                    });
                                };
                                
                                if (currentMatch?.start_date) {
                                    return formatDate(currentMatch.start_date);
                                }
                                return language === "AR" ? "1 يناير 2025" : "1st January 2025";
                            })()}
                        </div>
                        {/* <div className='text-sm font-SaudiaRegular mt-8'>room for some copy here</div> */}
                        </div>
                    </div>
                    </div>
                    </>
                    )}
                    
                    {/* Hidden PDF Content - Only visible when generating PDF */}
                    {pdfUserData && (
                        <div 
                            id="pdfContent" 
                            className={`pdf-hidden-root ${language === "AR" ? "rtl" : "ltr"}`}
                            dir={language === "AR" ? "rtl" : "ltr"}
                        >
                            {/* Game Day Prediction Section - Matching confirmation screen design */}
                            <div className="pdf-prediction-card relative overflow-hidden">
                                <img src={bgImg} alt="" className="absolute inset-0 w-full h-full object-cover pointer-events-none" />
                                <div className="relative z-10">
                                {/* Official Airline Partner */}
                                <div className="mt-3 mb-4 flex justify-center">
                                    <img 
                                        src={OfficialAirlinePartner} 
                                        alt="Official Airline Partner"
                                        className="max-w-[200px] h-auto"
                                    />
                                </div>
                                
                                {/* Title */}
                                <h3 className="text-2xl mb-0 font-SaudiaLight capitalize text-white">
                                    {language === "AR" ? "لعبتك" : "Your game"}
                                </h3>
                                <h3 className="text-2xl mb-2 font-SaudiaBold capitalize text-white">
                                    {language === "AR" ? "توقع يوم المباراة" : "day prediction"}
                                </h3>
                                
                                {/* Score Boxes */}
                                <div className="grid grid-cols-2 gap-2 relative mt-6">
                                    {(() => {
                                        // Get match data - prefer from pdfUserData, fallback to matchData
                                        let teamA = "Team A";
                                        let teamB = "Team B";
                                        let teamAScore = pdfUserData?.score?.teamA_score || 0;
                                        let teamBScore = pdfUserData?.score?.teamB_score || 0;
                                        let matchDate = null;
                                        
                                        if (matchData.length > 0 && currentMatchIndex < matchData.length) {
                                            const currentMatch = matchData[currentMatchIndex];
                                            teamA = getLocalizedFieldValue(currentMatch, language, "teamA_name") || "Team A";
                                            teamB = getLocalizedFieldValue(currentMatch, language, "teamB_name") || "Team B";
                                            matchDate = currentMatch.start_date;
                                        }
                                        
                                        const formatDate = (dateString) => {
                                            if (!dateString) return "";
                                            const date = new Date(dateString);
                                            return date.toLocaleDateString('en-GB', { 
                                                day: 'numeric', 
                                                month: 'long', 
                                                year: 'numeric' 
                                            });
                                        };
                                        
                                        return (
                                            <>
                                                {/* Home Team */}
                                                <div className="bg-[#241F20] flex flex-col gap-1.5 p-2.5">
                                                    <span className="text-[10px] font-SaudiaRegular text-white">
                                                        {language === "AR" ? "المنزل" : "Home"}
                                                    </span>
                                                    <h4 className="text-sm font-SaudiaMedium text-white m-0">
                                                        {teamA}
                                                    </h4>
                                                    <h5 className="text-6xl font-SaudiaExtraBold flex-1 flex items-center justify-center py-2 mt-2.5 text-white mb-0">
                                                        {teamAScore}
                                                    </h5>
                                                </div>
                                                
                                                {/* Vs Badge */}
                                                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#00D9A5] px-3 py-2 w-[50px] h-[50px] flex items-center justify-center text-2xl font-SaudiaBold z-10 text-white">
                                                    {language === "AR" ? "ضد" : "Vs"}
                                                </div>
                                                
                                                {/* Away Team */}
                                                <div className="bg-[#132257] flex flex-col gap-1.5 p-2.5">
                                                    <span className="text-[10px] font-SaudiaRegular text-white">
                                                        {language === "AR" ? "الضيوف" : "Away"}
                                                    </span>
                                                    <h4 className="text-sm font-SaudiaMedium text-white m-0">
                                                        {teamB}
                                                    </h4>
                                                    <h5 className="text-6xl font-SaudiaExtraBold flex-1 flex items-center justify-center py-2 mt-2.5 text-white mb-0">
                                                        {teamBScore}
                                                    </h5>
                                                </div>
                                                
                                                {/* Match Date */}
                                                <div className="col-span-2 text-xs font-SaudiaBold mt-5 text-white">
                                                    {matchDate ? formatDate(matchDate) : (language === "AR" ? "1 يناير 2025" : "1st January 2025")}
                                                </div>
                                                
                                                {/* Placeholder text */}
                                                {/* <div style={{ 
                                                    gridColumn: '1 / -1',
                                                    fontSize: '14px', 
                                                    fontFamily: 'SaudiaRegular', 
                                                    marginTop: '32px',
                                                    color: '#fff'
                                                }}>
                                                    room for some copy here
                                                </div> */}
                                            </>
                                        );
                                    })()}
                                </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                )}
            </div>
            {showInfoModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
                    <div className="bg-saudiaGreen max-w-[330px] text-center px-4 py-6 relative rounded-sm">

                        <h3 className="text-white text-2xl font-SaudiaBoldItalic mb-3">
                            {/* {language === "AR" ? "معلومات المباراة" : "Match Info"} */}
                            {language === "AR" ? "تذكرنى" : "Remember me"}
                        </h3>

                        <p className="text-white text-sm font-SaudiaRegular leading-relaxed mb-6">
                            {quizData ? (
                                getLocalizedFieldValue(quizData, language, "match_info") ||
                                (language === "AR" 
                                    ? "لا توجد معلومات متاحة عن المباراة" 
                                    : "No match information available")
                            ) : (
                                language === "AR" 
                                    ? "لا توجد معلومات متاحة عن المباراة" 
                                    : "No match information available"
                            )}
                        </p>

                        <button onClick={() => setShowInfoModal(false)} className="text-white underline font-SaudiaRegular text-sm">
                            {language === "AR" ? "إغلاق" : "Close"}
                        </button>

                    </div>

                    {/* Click outside to close */}
                    <div
                        onClick={() => setShowInfoModal(false)}
                        className="absolute inset-0"
                    />
                </div>
            )}
        </>
    )
}

export default Index
